import React, { useState } from "react";
import styled from "styled-components";
import AccordionTitle from "./AccordionTitle";
import { IAccordionData } from "../../commonTypes";
import Collapse from "../Collapse/Collapse";

const AccordionItem = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid rgb(255, 255, 255, 0.1);
  }
`;

const AccordionContent = styled.div`
  margin: 0 auto;
  padding: 0 20px 0 80px;
  height: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileM}) {
    padding-left: 50px;
  }
`;

interface IAccordionItemsProps {
  accordionContent: IAccordionData[];
  openOnMount: boolean;
}

interface IOpenedSections {
  [key: number]: boolean;
}

const createOpenedSectionsMap = (
  sectionsCount: number,
  openOnMount: boolean
): IOpenedSections =>
  new Array(sectionsCount).fill(0).reduce(
    (result, item, index) => ({
      ...result,
      [index]: openOnMount,
    }),
    {}
  );

const AccordionItems = ({
  accordionContent,
  openOnMount,
}: IAccordionItemsProps) => {
  const [openedSections, setOpenedSections] = useState<IOpenedSections>(
    createOpenedSectionsMap(accordionContent.length, openOnMount)
  );

  const handleOnClick = (accordionNumber: number) => {
    setOpenedSections((sections) => ({
      ...sections,
      [accordionNumber]: !sections[accordionNumber],
    }));
  };

  return (
    <>
      {accordionContent.map(
        ({ title, checkboxName, paragraphs }: any, index: number) => {
          const isOpen = openedSections[index];

          return (
            <AccordionItem key={`accordion-item-${index}`}>
              <AccordionTitle
                title={title}
                checkboxName={checkboxName}
                isOpen={isOpen}
                onClick={() => handleOnClick(index)}
              />
              <Collapse isOpen={isOpen}>
                <AccordionContent>{paragraphs}</AccordionContent>
              </Collapse>
            </AccordionItem>
          );
        }
      )}
    </>
  );
};

export default AccordionItems;
